import { useQuery, useMutation, useQueryClient } from '../lib/queryClient';
import { getUsers, postResetPassword } from '../helpers/chatApiClient';
import type { AdminUserView } from '../endpoints/admin/users_GET.schema';

export const ADMIN_USERS_QUERY_KEY = ['admin', 'users'] as const;

export function useAdminUsers() {
  return useQuery({
    queryKey: ADMIN_USERS_QUERY_KEY,
    queryFn: async () => {
      const data = await getUsers();
      return data.users as AdminUserView[];
    },
  });
}

export function useResetUserPassword() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: { userId: number; newPassword: string }) => {
      return await postResetPassword(data);
    },
    onSuccess: () => {
      // Invalidate users list just in case, though password change doesn't affect the list content usually.
      // It's good practice to keep data fresh.
      queryClient.invalidateQueries({ queryKey: ADMIN_USERS_QUERY_KEY });
    },
  });
}
